import { render } from "./MainScreen.vue?vue&type=template&id=1480c79c&scoped=true"
import script from "./MainScreen.vue?vue&type=script&lang=js"
export * from "./MainScreen.vue?vue&type=script&lang=js"

import "./MainScreen.vue?vue&type=style&index=0&id=1480c79c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1480c79c"]])

export default __exports__